import { Skeleton, TableCell, TableRow } from '@mui/material'

/**
 * Placeholder rows for a table that is still loading, rendered inside the
 * caller's own `<TableBody>`.
 *
 * A centred spinner tells the reader nothing about what is arriving and
 * collapses the table to zero height, so the page jumps when data lands. Rows
 * in the table's own shape hold the layout still and show the shape of the
 * answer before the answer exists.
 *
 * Bar widths vary per row on purpose. Identical widths read as a loading
 * graphic; uneven ones read as text that has not resolved yet.
 */
const WIDTHS = ['72%', '54%', '86%', '61%', '78%', '48%', '69%', '83%', '57%']

export default function TableSkeleton({
  rows = 8,
  columns,
  rowHeight = 44,
}: {
  rows?: number
  columns: number
  rowHeight?: number
}) {
  return (
    <>
      {Array.from({ length: rows }, (_, row) => (
        <TableRow key={row} sx={{ height: rowHeight }}>
          {Array.from({ length: columns }, (_, col) => (
            <TableCell key={col}>
              <Skeleton
                variant="rounded"
                height={9}
                width={WIDTHS[(row * columns + col) % WIDTHS.length]}
                sx={{ borderRadius: 99 }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  )
}
